import {
  formatDateISO,
  getWeekDates,
  getWeekStart,
} from "../../../../Moduels/attendance/attendanceService";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export { MONTH_NAMES };

/** Unique Monday week-starts that intersect the given calendar month. */
export function getWeeksInMonth(year, month) {
  const seen = new Set();
  const result = [];
  const lastDay = new Date(year, month + 1, 0).getDate();

  for (let day = 1; day <= lastDay; day += 1) {
    const d = new Date(year, month, day);
    const ws = getWeekStart(d, 0);
    const key = formatDateISO(ws);
    if (!seen.has(key)) {
      seen.add(key);
      result.push(new Date(ws));
    }
  }

  return result.sort((a, b) => a.getTime() - b.getTime());
}

export function buildWeekDays(weekStart) {
  const dates = getWeekDates(weekStart);
  const today = formatDateISO(new Date());
  return dates.map((d, i) => ({
    date: formatDateISO(d),
    label: DAY_LABELS[i],
    isToday: formatDateISO(d) === today,
  }));
}

export function formatWeekLabel(weekStart) {
  const dates = getWeekDates(weekStart);
  const fmt = (d) =>
    d.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  return `${fmt(dates[0])} – ${fmt(dates[6])}`;
}

export function defaultWeekIndexForMonth(year, month, weeks) {
  const now = new Date();
  if (now.getFullYear() !== year || now.getMonth() !== month) {
    return 0;
  }
  const today = formatDateISO(now);
  const idx = weeks.findIndex((ws) => {
    const days = getWeekDates(ws).map(formatDateISO);
    return days.includes(today);
  });
  return idx >= 0 ? idx : 0;
}

export function buildYearOptions(anchorYear = new Date().getFullYear()) {
  return [anchorYear - 1, anchorYear, anchorYear + 1];
}
